import type { ConfigRequest } from '@pba/react-utils';
import type { paths } from '@pba/types-openapi-node';
import { type ApiClientResponse, nodeApiClient, nodeApiRoutes } from 'common/services';

type FindNodeCommunitiesDataObject =
  paths['/communities']['get']['responses']['default']['content']['application/json'];
type FindNodeCommunitiesRequest = paths['/communities']['get']['parameters']['query'];

export const findNodeCommunities = async ({ config }: ConfigRequest<FindNodeCommunitiesRequest>) =>
  nodeApiClient.get<FindNodeCommunitiesDataObject, ApiClientResponse<FindNodeCommunitiesDataObject>>(
    nodeApiRoutes.communities.find,
    config,
  );
